export const dashboardEs = {
  // shared — DashboardNav
  'dashboard.nav.ariaLabel': 'Secciones del panel de control',
  'dashboard.nav.overview': 'Resumen',
  'dashboard.nav.avatar': 'Avatar',
  'dashboard.nav.coins': 'Monedas',
  'dashboard.nav.contributions': 'Aportaciones',

  // shared — StatusBadge (contribution status)
  'dashboard.status.draft': 'Borrador',
  'dashboard.status.submitted': 'Enviada',
  'dashboard.status.communityReview': 'Revisión Comunitaria',
  'dashboard.status.officialReview': 'Revisión Oficial',
  'dashboard.status.approved': 'Aprobada',
  'dashboard.status.rejected': 'Rechazada',
  'dashboard.status.unknown': 'desconocida',

  // shared — ClaimStatusBadge
  'dashboard.claimStatus.pending': 'pendiente',
  'dashboard.claimStatus.approved': 'aprobada',
  'dashboard.claimStatus.rejected': 'rechazada',

  // DashboardPage
  'dashboard.seo.title': 'Mi Grymwyrd',
  'dashboard.seo.description': 'Tus monedas, reclamaciones, aportaciones y personajes en el crepúsculo eterno.',
  'dashboard.displayNameFallback': 'Viajero',
  'dashboard.welcomeBack': 'Bienvenido de vuelta',
  'dashboard.editAvatar': 'Editar avatar',
  'dashboard.loading': 'Recuperando tu leyenda…',
  'dashboard.avatarAlt': 'Retrato de {name}',
  'dashboard.offlineNotice':
    'Los datos en vivo no están disponibles — mostrando tu última sesión conocida y contenido de ejemplo.',

  // DashboardPage — Coins card
  'dashboard.coins.title': 'Monedas Sepulcrales',
  'dashboard.coins.viewAll': 'Ver todas',
  'dashboard.coins.unit': 'monedas',
  'dashboard.coins.noActivity': 'Sin actividad de monedas todavía.',
  'dashboard.coins.fullHistory': 'Historial completo y comprar monedas',

  // DashboardPage — Contributions card
  'dashboard.contributions.title': 'Aportaciones',
  'dashboard.contributions.manage': 'Gestionar',
  'dashboard.contributions.empty': 'Sin aportaciones todavía — escribe la primera.',

  // DashboardPage — Claims card
  'dashboard.claims.title': 'Territorios Reclamados en Grymwyrd',
  'dashboard.claims.empty': 'Aún no posees territorio alguno en Grymwyrd.',
  'dashboard.claims.kindClaimed': '{kind} · reclamado {date}',

  // DashboardPage — Characters card
  'dashboard.characters.title': 'Personajes',
  'dashboard.characters.empty': 'Sin almas vinculadas a tu nombre.',
  'dashboard.characters.level': 'Nv {level}',
  'dashboard.characters.unknown': 'Desconocido',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': 'Editor de Avatar',
  'dashboard.avatarEditor.seo.description': 'Modela el rostro que muestras al mundo de Grymwyrd.',
  'dashboard.avatarEditor.heading': 'Editor de Avatar',
  'dashboard.avatarEditor.errorNotImage': 'Ese archivo no es una imagen.',
  'dashboard.avatarEditor.errorNameRequired': 'Se requiere un nombre, incluso en la oscuridad.',
  'dashboard.avatarEditor.portrait': 'Retrato',
  'dashboard.avatarEditor.portraitPreview': 'Vista previa del retrato',
  'dashboard.avatarEditor.avatarPreviewAlt': 'Vista previa del avatar',
  'dashboard.avatarEditor.zoom': 'Zoom',
  'dashboard.avatarEditor.zoomAria': 'Zoom del retrato',
  'dashboard.avatarEditor.panHorizontal': 'Desplazar retrato horizontalmente',
  'dashboard.avatarEditor.panVertical': 'Desplazar retrato verticalmente',
  'dashboard.avatarEditor.uploadAria': 'Subir imagen de retrato',
  'dashboard.avatarEditor.changeImage': 'Cambiar imagen',
  'dashboard.avatarEditor.uploadImage': 'Subir imagen',
  'dashboard.avatarEditor.identity': 'Identidad',
  'dashboard.avatarEditor.displayName': 'Nombre visible',
  'dashboard.avatarEditor.backstory': 'Trasfondo',
  'dashboard.avatarEditor.backstoryPlaceholder': '¿De dónde viniste y qué destino sombrío persigues?',
  'dashboard.avatarEditor.publicProfile': 'Perfil público',
  'dashboard.avatarEditor.publicVisible': 'Visible en la Sala de Leyendas.',
  'dashboard.avatarEditor.publicHidden': 'Oculto de otros viajeros.',
  'dashboard.avatarEditor.saving': 'Guardando…',
  'dashboard.avatarEditor.saveChanges': 'Guardar cambios',
  'dashboard.avatarEditor.saved': 'Guardado',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'El pago aún no está disponible — las arcas permanecen cerradas.',
  'dashboard.coinHistory.notEnoughCoins': 'No tienes suficientes monedas para eso.',
  'dashboard.coinHistory.reasonWorldClaim': 'Reclamación territorial',
  'dashboard.coinHistory.reasonCosmetic': 'Cosmético',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': 'Gastaste {cost} monedas en {name}.',
  'dashboard.coinHistory.seo.title': 'Monedas Sepulcrales',
  'dashboard.coinHistory.seo.description': 'Tu registro de monedas completo, recargas y la mercancía de los muertos.',
  'dashboard.coinHistory.heading': 'Monedas Sepulcrales',
  'dashboard.coinHistory.balance': 'saldo',
  'dashboard.coinHistory.buyCoins': 'Comprar Monedas',
  'dashboard.coinHistory.packCoins': '{coins} monedas',
  'dashboard.coinHistory.packBonus': ' + {bonus} bonificación',
  'dashboard.coinHistory.summoningCheckout': 'Invocando pago…',
  'dashboard.coinHistory.purchase': 'Comprar',
  'dashboard.coinHistory.spendCoins': 'Gastar Monedas',
  'dashboard.coinHistory.insufficientCoins': 'Monedas insuficientes',
  'dashboard.coinHistory.spending': 'Gastando…',
  'dashboard.coinHistory.spendAmount': 'Gastar {cost}',
  'dashboard.coinHistory.historyTitle': 'Historial',
  'dashboard.coinHistory.tallyingLedger': 'Cuadrando el registro…',
  'dashboard.coinHistory.tableCaption': 'Historial de transacciones de monedas',
  'dashboard.coinHistory.colReason': 'Razón',
  'dashboard.coinHistory.colAmount': 'Cantidad',
  'dashboard.coinHistory.noTransactions': 'Sin transacciones todavía.',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': 'Mis Aportaciones',
  'dashboard.contributionsPage.seo.description':
    'La leyenda que has escrito y su paso ante la mirada de los moderadores.',
  'dashboard.contributionsPage.heading': 'Aportaciones',
  'dashboard.contributionsPage.newContribution': 'Nueva Aportación',
  'dashboard.contributionsPage.loading': 'Desenrollando tus pergaminos…',
  'dashboard.contributionsPage.empty': 'Aún no has escrito leyenda alguna. Comienza con tu primera aportación.',
  'dashboard.contributionsPage.untitledDraft': 'Borrador sin título',
  'dashboard.contributionsPage.moderator': 'Moderador:',
  'dashboard.contributionsPage.entryFallback': 'Entrada',
  'dashboard.contributionsPage.errorNameRequired': 'Toda creación necesita un nombre.',
  'dashboard.contributionsPage.modalTitle': 'Nueva Aportación',
  'dashboard.contributionsPage.type': 'Tipo',
  'dashboard.contributionsPage.titleLabel': 'Título',
  'dashboard.contributionsPage.summaryLabel': 'Resumen',
  'dashboard.contributionsPage.saveDraft': 'Guardar borrador',
  'dashboard.contributionsPage.submitting': 'Enviando…',
  'dashboard.contributionsPage.submitForReview': 'Enviar para revisión',
} as const
